const GROUP_A_CODES = ['v4Bk0', 'v4Bk1a', 'v4Bk2a', 'v4Bk3a', 'v4Bk4a'];
const GROUP_B_CODES = ['v4Bk1b', 'v4Bk2b', 'v4Bk3b', 'v4Bk4b'];

export function getUnitRange(courseTypeLevelCode, reportName) {
  const isReport2 = reportName && /2/.test(reportName);
  if (GROUP_B_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? '7-12' : '7-10';
  }
  if (GROUP_A_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? '1-6' : '1-4';
  }
  return isReport2 ? '1-6' : '1-4';
}

export function getAverageScoreHeading(courseTypeLevelCode, reportName) {
  const unitRange = getUnitRange(courseTypeLevelCode, reportName);
  return `Average Score of Unit ${unitRange}`;
}


// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/unitRange.js